import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { capture, setBullrunConfig } from "@orb-labs/orby-react";
import { AppEvents } from "@orb-labs/orby-react/bullrun";
import { ErrorBoundary } from "@/ErrorBoundary";
import { initObservability } from "@/observability";
import { ENV } from "@/config/env";
import "@turnkey/react-wallet-kit/styles.css";
import "./fonts.css";
import App from "@/App";

initObservability();
// Register shared config so package code (shared screens rendered on mobile-web)
// can read APP_DOMAIN via getBullrunConfig(). Onramp / Crossmint stay empty —
// their RN-only flows don't execute on web.
setBullrunConfig({ appDomain: ENV.APP_DOMAIN });
capture(AppEvents.APP_OPENED, { platform: "web", referrer: document.referrer || undefined });

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);
